export const events = {
    // CSS_ANIMATIONS_CLEAR: "cssAnimations.CSS_ANIMATIONS_CLEAR",
    CSS_ANIMATIONS_ANIMATE: "cssAnimations.CSS_ANIMATIONS_ANIMATE",
    CSS_ANIMATIONS_CLASS: "animated",
    CSS_ANIMATIONS_PRE_CLASS: "not_animated",
    // CSS_ANIMATIONS_POST_CLASS: "post_animated",
    CSS_ANIMATION_RESET: "cssAnimations.CSS_ANIMATION_RESET"
}

export default {
    animate: obj => {
        return {
            type: events.CSS_ANIMATIONS_ANIMATE,
            state: true
        }
    },
    reset: (state=events.CSS_ANIMATIONS_RESET) => {
        return {
            type:events.CSS_ANIMATION_RESET,
            state: state
        }
    }
}